import dayjs, { Dayjs } from "dayjs";
import React, { useEffect, useState } from "react";
import { api_url } from "../../static_vars";
import Box from "@mui/material/Box";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";
import FarsightApi from "../../ApiWrapper";
import { Grow } from "@mui/material";
import {useReferentialContext} from "../../Context";
import {Player} from "../../farsight-api";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export default function CompetitivePlayerEvolution(props: {player: Player, year?: number|undefined}) {
    const [rows, setRows] = useState([] as any[]);
    const api = useReferentialContext().farsightApi.competitiveGameSummaries
    const { player } = props;

    useEffect(() => {
        api.aggregate(
            {
                player:props.player.player,
                groupby: ['team1,league,split,phase'],
                ordering: ['date__max'],
                additional_filters:{
                    date__year: 2023
                },
                metrics:['performance,relative_performance,games,winrate'],
                aggregates:['date__max']
            }
        ).then(result => setRows(result))
        // FarsightApi.get_request("PlayerPerformanceEvolution", props).then((data) => setRows(data));
        // fetch(api_url + "PlayerPerformanceEvolution/?player=" + player + "&format=json").then(response => response.json()).then(data => setRows(data));
    }, [props.player, props.year]);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top" as const,
            },
            title: {
                display: true,
                text: `${player.player} evolution`,
            },
        },
        lineTension: 0.3,
    };

    const data = {
        labels: rows.map((row: any) => `${row.team1} : ${row.split ? row.split : ''} ${row.league} ${row.phase ? row.phase : ''}\n${row.games} games, ${(row.winrate === true ? 100 : row.winrate * 100).toFixed(1)}% WR`) as string[],
        datasets: [
            {
                label: "Performance",
                data: rows.map((row: any) => row.performance),
                fill: true,
                backgroundColor: "rgba(75,192,192,0.2)",
                borderColor: "rgba(75,192,192,1)",
                pointRadius: 10,
                pointHoverRadius: 15,
            },
            {
                label: "Relative Performance",
                data: rows.map((row: any) => row.relative_performance),
                fill: false,
                borderColor: "#742774",
                pointRadius: 10,
                pointHoverRadius: 15,
            },
            {
                label: "0",
                data: rows.map((row: any) => 0),
                fill: false,
                borderColor: "#d81832",
                pointRadius: 0,
            },
        ],
    };

    return (
        <Grow in={true} style={{ transformOrigin: "0 -50 0" }} {...{ timeout: 2000 }}>
            <Box sx={{ width: "100%", height: "100%" }}>
                <Line options={options} data={data} />
            </Box>
        </Grow>
    );
}
